import axios from 'axios'
import BaseService from './base.service'
import { getTokenV3 } from './axios'
import store from '@/store/index'

const API_URL = process.env.VUE_APP_API_URL
const EXTERNAL_ID_TYPE = process.env.VUE_APP_EXTERNAL_ID_TYPE
const SETTING_JSON = process.env.VUE_APP_SETTING_JSON || ''

const userInfo: any = store.state.userInfo
interface reBetSportsInterface {
    url: string
    code: string
    betId: string
    token: string
}
class BetslipsService extends BaseService {
    async searchBetslip(id: string, detailByScanner: boolean = false) {
        const settings = JSON.parse(SETTING_JSON)
        return await this.get(`${settings.url}/api/retail/betslip/detail/${id}`, {'tis': detailByScanner}).then(({ data }) => data)
    }

    async checkRebetLoto(id: string) {
        const settings = JSON.parse(SETTING_JSON)
        return await this.get(`${settings.url}/api/retail/betslip/detail-for-rebet/L-${id}`).then(({ data }) => data)
    }

    async reBetTickets(reference: string) {
        const payload = {
            account: store.state.userInfo.gamev3.account,
            currency: store.state.userInfo.gamev3.currency_code,
            reference: reference,
            client_token: store.state.tokenV3 !== null ? store.state.tokenV3 : getTokenV3(),
        }

        const response = await this.postAuth2(`${API_URL}/api/multi-lotto/wager`, payload)

        return response.data
    }

    async reBetTicket645(externalId: string) {
        const payload = {
            account: store.state.userInfo.gamev3.account,
            currency: store.state.userInfo.gamev3.currency_code,
            externalId: externalId,
            client_token: store.state.tokenV3 !== null ? store.state.tokenV3 : getTokenV3(),
        }

        const response = await this.postAuth2(`${API_URL}/api/pari-mutuel-lotto/wager`, payload)

        return response.data
    }

    async reBetSports(param: reBetSportsInterface) {
        const { url, code, betId, token } = param

        const axiosTokenlessInstance = axios.create({
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
        })

        const response = await axiosTokenlessInstance.post(`${url}/sports/rebet?admin_user_id=${userInfo?.details?.id}&code=${code}&ref=${betId.replace('S-', '')}`)

        return response.data
    }

    transactLotto = (entries: any, bet_timestamp, typeGame: string, rebetFromBetslip = '', freebet: any = null) => {
        let gs = '';
        try {
            gs = (entries ?? [])[0]?.game;
        } catch {}
        const additionalInformation: any = {
            admin_user_id: userInfo?.details?.id || '',
            rebet_from_betslip: rebetFromBetslip && rebetFromBetslip.trim() !== '' ? rebetFromBetslip.replace('L-', '') : '',
            bet_timestamp: bet_timestamp,
            game_slug: gs,
        }
        const payload: any = {
            account: store.state.userInfo.gamev3.account,
            additionalInformation,
            currency: store.state.userInfo.gamev3.currency_code,
            retail: 'yes',
            customerID: store.state.userInfo.gamev3.lotto_retail_user,
            client_token: store.state.tokenV3 !== null ? store.state.tokenV3 : getTokenV3(),
            external_id_type: EXTERNAL_ID_TYPE,
            bets: [
                {
                    entries: entries,
                },
            ],
        }

        // Extra 7 Boost — FreeBet play: stake funded by a Boost-win coupon, not the
        // cashier. Flag both at the top level and in additionalInformation so the
        // lottery skips the retailer balance gate and retail records the bet as a
        // freebet (excluded from float / commission, paired in GGR).
        if (freebet && freebet.code) {
            payload.free_bet = true
            payload.freebet_code = freebet.code
            additionalInformation.free_bet = true
            additionalInformation.freebet_code = freebet.code
        }

        return this.postAuth2(`${API_URL}/api/${typeGame ? typeGame : 'multi-lotto'}/transact`, payload).then(({ data }) => data)
    }

    async cancelBetslip(betslipId: string, fromReprint = false) {
        const settings = JSON.parse(SETTING_JSON)

        const url = fromReprint
            ? `${settings.url}/api/retail/betslip/cancel/${betslipId}?from_reprint=true`
            : `${settings.url}/api/retail/betslip/cancel/${betslipId}`

        return await this.get(url).then(({ data }) => data)
    }

    async deviceBindingcheck() {
        const settings = JSON.parse(SETTING_JSON)

        return await this.post(`${settings.url}/api/retail/cashier/device-binding-check`, '').then(({ data }) => data)
    }

    async settleBetslip(id: string, forRaffle = false, detailByScanner = false) {
        const settings = JSON.parse(SETTING_JSON)
        let sub = ""
        if(forRaffle) sub = "?is_raffle_payment=true";
        // LINHDINH todo: set header of api: x-by-scanner: detailByScanner
        return await this.get(`${settings.url}/api/retail/betslip/cashout/${id}${sub}`, {'Ticket-Is-Scanned': detailByScanner}).then(({ data }) => data)
    }

    async updatePrintingStatus(ticketType:string, reference: string, reprintCount = 0, success = true) {
        const settings = JSON.parse(SETTING_JSON)
        let payload = {ticketType, reference, reprintCount, reprint: reprintCount > 0, success}
        return await this.post(`${settings.url}/api/retail/cashier/update-print-status`, payload).then(({ data }) => data)
    }

    async notifyPrintStatus(statusResp: any, context: any = null) {
        const settings = JSON.parse(SETTING_JSON)
        const reprintCount = context?.reprintCount ?? 0
        const payload = {
            deviceInfo: statusResp?.deviceInfo,
            success: statusResp?.code === 200,
            code: statusResp?.code,
            message: statusResp?.message,
            data: statusResp?.data,
            errorCode: statusResp?.errorCode,
            nativeCode: statusResp?.nativeCode,
            nativeMessage: statusResp?.nativeMessage,
            ticketType: context?.ticketType ?? null,
            ticketId: context?.ticketId ?? null,
            reference: context?.reference ?? null,
            reprintCount,
            reprint: reprintCount > 0,
        }
        return await this.post(`${settings.url}/api/retail/cashier/update-print-status`, payload).then(({ data }) => data)
    }
}

export default new BetslipsService()
